/* global axios */
import ApiClient from './ApiClient';

// Central de avisos: get() lista os avisos ABERTOS visíveis ao papel do
// usuário; resolve(id, resolution) fecha um ('fixed' | 'ignored').
class OpsNoticesAPI extends ApiClient {
  constructor() {
    super('ops_notices', { accountScoped: true });
  }

  resolve(id, resolution) {
    return axios.post(`${this.url}/${id}/resolve`, { resolution });
  }
}

export default new OpsNoticesAPI();
